var exports = {
  "g4": "InviteModal.module__loadingContainer___R1dtOX",
  "qy": "InviteModal.module__channelSubtitle___R1dtOX",
  "HA": "InviteModal.module__channelName___R1dtOX",
  "p": "InviteModal.module__channelIcon___R1dtOX",
  "ak": "InviteModal.module__inviteButton___R1dtOX",
  "UW": "InviteModal.module__warningContainer___R1dtOX",
  "QW": "InviteModal.module__warningIcon___R1dtOX",
  "i4": "InviteModal.module__warningText___R1dtOX",
  "xr": "InviteModal.module__expirationText___R1dtOX",
  "bv": "InviteModal.module__editLink___R1dtOX",
  "Wm": "InviteModal.module__detailedView___R1dtOX",
  "WT": "InviteModal.module__noChannelContent___R1dtOX",
  "Q9": "InviteModal.module__noChannelIcon___R1dtOX",
  "E_": "InviteModal.module__noChannelText___R1dtOX",
};

module.exports = exports;
